import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
import type { ITiposGeneralesContrato, IConfServicios } from '@/modules/Contratacion/interfaces'
export class ServicioService extends BaseService<IConfServicios> {
  constructor () {
    super({
      baseUrl: 'system/services/'
    })
  }
  async getGenerales(): Promise<AxiosResponse<IResponseApi<ITiposGeneralesContrato>>> {
    return this.http.get<IResponseApi<ITiposGeneralesContrato>>(`/general`)
  }
  async searchByname (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfServicios[]>>> {
    return this.http.get<IResponseApi<IConfServicios[]>>('/search-by-name', {params})
  }
}
